module.exports = __webpack_public_path__ + "img/IcnAsr.6066c73d.png";